<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view v-if="bIsRouterAlive" />
</template>
<script setup>
import { nextTick, provide, ref } from "vue";
// 控制 router-view 是否显示达到刷新效果
const bIsRouterAlive = ref(true);
const fReload = () => {
  // 通过 bIsRouterAlive 控制 router-view 达到刷新效果
  bIsRouterAlive.value = false;
  nextTick(() => {
    bIsRouterAlive.value = true;
  });
};
provide("reload", fReload);
</script>
<style lang="scss">
#app {
  text-align: center;

  color: #2c3e50;

  font-family: Avenir, Helvetica, Arial, sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

nav {
  padding: 30px;

  a {
    color: #2c3e50;

    font-weight: bold;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.el-loading-spinner .path {
  -webkit-animation: loading-dash 1.5s ease-in-out infinite;
          animation: loading-dash 1.5s ease-in-out infinite;

  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  /* stroke: var(--el-color-primary); */
  stroke-linecap: round;
  stroke: #0ba29a !important;
}

.el-loading-spinner .el-loading-text {
  margin: 3px 0;
  /* color: var(--el-color-primary); */

  color: #0ba29a !important;

  font-size: 14px;
}

// 分页hover效果
// .el-pagination.is-background .el-pager li:not(.is-disabled):hover {
//   color: #0ba29a !important;
// }

</style>
